/**
 * How long ago, in the fewest characters: "now", "5m", "2h", "3d", then
 * the date. The full timestamp rides along as the hover title. Mays:
 * "reduce size of font on notification dropdown ... make more sleek and
 * organized" — a full "11/3/2026, 12:52:37 PM" under every row was the
 * widest thing in it and the least read.
 */
export function notificationAge(iso, now = new Date()) {
  const at = iso ? new Date(iso) : null;
  if (!at || !Number.isFinite(at.getTime())) return '';
  const seconds = Math.max(0, Math.round((now.getTime() - at.getTime()) / 1000));
  if (seconds < 60) return 'now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days}d`;
  return at.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
